import { RestClient } from "./restClient";

const logLevels = {
	fatal: "fatal",
	error: "error",
	warn: "warn",
	info: "info",
	debug: "debug",
	trace: "trace"
};

export class LogService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	log(app, level, method, message, callback) {
		const url = `/${app}/api/_log`;
		const body = JSON.stringify({
			level: level,
			method: method,
			message: message
		});
		this._restClient.exec_post(url, body, callback);
	}

	logMetric(app, metricName, metric, callback) {
		const url = `/${app}/api/_logMetric`;
		const body = JSON.stringify({
			metricName: metricName,
			metric: metric
		});
		this._restClient.exec_post(url, body, callback);
	}
}

LogService.LogLevels = logLevels;
